module.exports = __webpack_public_path__ + "img/drc-logo.f15950b3.svg";